// Detect current brand and expose helpers
const { REACT_APP_BRAND } = process.env;

export const isAzaform =
  (typeof window !== "undefined" && window.location.hostname.includes("azaform")) ||
  REACT_APP_BRAND === "azaform";

export const brandName = isAzaform ? "Azaform" : "Central Feedback";
export const brandDomain = isAzaform ? "azaform.com" : "centralfeedback.com";

// Optional: email addresses if they differ per brand in future
export const brandSupportEmail = isAzaform ? "support@azaform.com" : "paul@centralfeedback.com";
